import { ReactNode } from 'react';

import { queryClient, QueryClientProvider } from '~src/services/client';

export const QueryContext = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
